export default __webpack_public_path__ + "content/media/12.cc20cca7.jpg";